<script>
	import { onMount } from 'svelte'
    import { FormationsData, BrillianceData } from '../../script/_data'
    import { CheckLink, ChangeFormation, GetWriteMonsterList, CheckSelectMonster  } from '../../script/handle/write'

    export let Formation, Brilliance
    let txtBrilliance = ['탄창', '비탄창', '가호', '재능', '강림']
    let monsterList = []

    let leftHeight, rightHeight, barHeight
    $:if(leftHeight>rightHeight)
        {barHeight=leftHeight} else {barHeight=rightHeight}

	onMount(async () => {
        //monsterList = GetWriteMonsterList()
        monsterList = CheckSelectMonster(GetWriteMonsterList())
    })

    // 대형 선택
    function changeFormation() {
        ChangeFormation()
    }
</script>

<div class='info'>
    <div class="attention">
        <div class="title">※ 참고 및 주의사항</div>
        <ul>
            <li>대형에서 선택 가능한 몬스터는 <strong>몬스터</strong> 탭에서 지정한 몬스터만 가능합니다.</li>
            <li>버그 또는 오타가 있는 경우, 제보 부탁드립니다. => (<a href="https://open.kakao.com/me/admin_turtle" rel="noopener noreferrer" target="_blank">제보</a>)</li>
        </ul>
    </div>

    <div class="position" bind:clientHeight={leftHeight}>
        <div class="positionSelect">
            <div class="title">대형 선택 : </div>
            <select bind:value={Formation.num} on:change={changeFormation}>
                <option value={-1}>미선택</option>
                {#each FormationsData as formation}
                    <option value={formation.num}>{formation.name}</option>
                {/each}
            </select>
        </div>

        <div class="positionDetail">
            {#if Formation.num == -1}
                <div class="not">
                    <svg xmlns="http://www.w3.org/2000/svg" class='top' width="25" height="18" viewBox="0 0 25 18" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2613 4.85226L19.1537 0H-4.88758e-06V4.85226H2.82704e-05V12.3063L4.85229 17.4139L4.85229 4.85226H24.2613Z" fill="#F5124D"/>
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" class="bottom" width="25" height="18" viewBox="0 0 25 18" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.57764e-05 12.5618L5.10769 17.4141H24.2614V12.5618H24.2613V5.10781L19.4091 0.000162125L19.4091 12.5618H4.57764e-05Z" fill="#F5124D"/>
                    </svg>

                    <div class="txt">선택된 대형이 없습니다.</div>
                </div>
            {:else}
                <div class="img">
                    <img
                        src="{CheckLink()}/img/formation/{Formation.num}.png"
                        alt="formation_{Formation.num}"
                    >
                    {FormationsData[Formation.num-1].name}
                </div>
                
                <div class="form">
                    {#each Formation.data as data, i}
                        <div class="grid">
                            <label>{i+1}: </label>

                            <select
                                bind:value={data}
                                disabled={i==0}
                                on:change={() => monsterList = CheckSelectMonster(monsterList)}
                            >
                                <option value={-1}>미선택</option>

                                {#each monsterList as monster}
                                    <option
                                        value={monster.num}
                                        disabled={monster.select}
                                    >
                                        {monster.name}
                                    </option>
                                {/each}
                            </select>
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
    </div>

    <div class="bar" style="height:{barHeight}px;"></div>

    <div class="brilliance" bind:clientHeight={rightHeight}>
        <div class="title">마신 축복</div>
        
        <div class="form">
            {#each txtBrilliance as txt, i}
                <div class="grid">
                    <label>{txt}</label>
                    <select bind:value={Brilliance[i]}>
                        <option value={-1}>미선택</option>
                        {#each BrillianceData as brilliance}
                            <option value={brilliance.num}>{brilliance.name}</option>
                        {/each}
                    </select>
                </div>
            {/each}
        </div>
    </div>
</div>

<style lang="scss">
    .info {
        width: 100%;
        max-width: 1200px;
        height: fit-content;
        margin: 0 auto;

        .attention {
            background: rgba($color: $cl3, $alpha: 0.3);
            width: calc(100% - 20px);
            height: fit-content;
            padding: 30px 10px;

            .title {
                color: $cl4;
                font-size: 15px;
                font-family: aggro;
            }

            ul, ol {
                margin: 0px;
                padding-left: 25px;
                font-size: 15px;

                li {
                    margin: 5px 0px;
                    word-break: keep-all;
                }

                a {
                    padding: 4px;
                    border-radius: $br1;
                    color: $cl4;
                    font-family: aggro;

                    &:hover {
                        background: $cl5;
                        color: $cl2;
                    }
                }
            }
        }

        .bar {
            background: $cl3;
            width: 1px;
            height: 10px;
            margin: 50px;
            display: inline-block;
        }

        .position {
            width: calc(60% - 20px - 51px);
            height: fit-content;
            margin: 50px 10px;
            display: inline-block;
            vertical-align: top;

            .positionSelect {
                margin-bottom: 20px;

                .title {
                    margin-right: 13px;
                    color: $cl3;
                    font-size: 15px;
                    font-family: aggro;
                    display: inline-block;
                }
                select { margin: 0px; cursor: pointer; }
            }
            .positionDetail {
                width: calc(100%);
                height: fit-content;

                .not {
                    width: calc(100% - 8px);
                    height: fit-content;
                    padding: 3px 4px;
                    position: relative;

                    .txt{
                        background: $cl4;
                        padding-top: 14px;
                        padding-bottom: 12px;
                        color: $cl2;
                        font-size: 20px;
                        font-family: aggro;
                        text-align: center;
                    }

                    svg {
                        position: absolute;

                        &.top {
                            top: 0;
                            left: 0;
                        }

                        &.bottom {
                            bottom: 0;
                            right: 0 ;
                        }
                    }
                }

                .img {
                    width: calc(30% - 20px);
                    height: fit-content;
                    padding: 0px 10px;

                    font-size: 15px;
                    font-family: aggro;
                    text-align: center;

                    display: inline-block;
                    vertical-align: top;

                    img { width: 100%; }
                }
                .form {
                    width: calc(70% - 20px);
                    height: fit-content;
                    padding: 0px 10px;
                    display: inline-block;
                    vertical-align: top;

                    .grid {
                        width: 100%;
                        height: fit-content;
                        margin-bottom: 10px;
                        display: grid;
                        grid-template-columns: calc(25%) calc(75% - 10px);
                        grid-column-gap: 10px;

                        label {
                            padding: 2px;
                            font-size: 14px;
                            vertical-align: middle;
                        }
                        select {
                            width: calc(100% - 4px);
                            margin: 0px;
                            vertical-align: middle;
                            cursor: pointer;

                            &:disabled { cursor: not-allowed; }

                            option {
                                &:disabled {
                                    background: $cl4;
                                    color: $cl2;
                                    cursor: not-allowed;
                                }
                            }
                        }
                    }
                }
            }
        }

        .brilliance {
            width: calc(40% - 20px - 51px);
            height: fit-content;
            margin: 50px 10px;
            display: inline-block;
            vertical-align: top;

            .title {
                margin-bottom: 20px;
                color: $cl3;
                font-size: 15px;
                font-family: aggro;
            }

            .form {
                width: calc(100%);
                height: fit-content;

                .grid {
                    width: 100%;
                    height: fit-content;
                    margin-bottom: 10px;
                    display: grid;
                    grid-template-columns: calc(25%) calc(75% - 10px);
                    grid-column-gap: 10px;

                    label {
                        padding: 2px;
                        font-size: 14px;
                        vertical-align: middle;
                    }
                    select {
                        width: calc(100% - 4px);
                        margin: 0px;
                        vertical-align: middle;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>